function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import muxReactNativeVideo from "@mux/mux-data-react-native-video";
import * as FileSystem from "expo-file-system/legacy";
import { activateKeepAwakeAsync, deactivateKeepAwake } from "expo-keep-awake";
import { LinearGradient } from "expo-linear-gradient";
import * as VideoThumbnails from "expo-video-thumbnails";
import hexToRgba from "hex-to-rgba";
import noop from "lodash/noop";
import { Component, createRef, forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react";
import { AccessibilityInfo, Animated, AppState, Image, Modal, PixelRatio, Platform, SafeAreaView, ScrollView, StyleSheet, TouchableOpacity } from "react-native";
import { SystemBars } from "react-native-edge-to-edge";
import Url from "url-parse";
import { getUserIDForThirdParties } from "@oui/lib/src/getUserIDForThirdParties";
import { getMuxThumbnail, isMuxUrl } from "@oui/lib/src/muxUrl";
import { ActivityIndicator } from "./ActivityIndicator";
import { CurrentUserContext } from "./CurrentUserContext";
import { Icon } from "./Icon";
import { RNSlider as Slider } from "./RNSlider";
import RNVideo, { SelectedTrackType, TextTrackType } from "./RNVideo";
import { Subtitles } from "./Subtitles";
import { Text } from "./Text";
import { TranscriptModal } from "./TranscriptModal";
import { View } from "./View";
import { APP_SLUG, manifest, MUX_ENV_KEY } from "../constants";
import { useFormatDuration } from "../hooks/useFormatDuration";
import { preloadPersistedState, setPersistedState } from "../hooks/usePersistedState";
import { catchChromeAutoplayError } from "../lib/catchChromeAutoplayError";
import { ResizeMode, Video, VideoFullscreenUpdate } from "../lib/expo-av";
import { getCachedUri, getMinuteSecondFromMillis, getMMSSFromMillis } from "../lib/mediaPlayer";
import { fetchIsConnected } from "../lib/NetInfo";
import { getVolume } from "../lib/systemSetting";
import Sentry from "../sentry";
import { Shadow, useTheme, WithTheme } from "../styles";
var MuxVideo = muxReactNativeVideo(RNVideo);
var MAX_RETRY_ATTEMPTS = 5;
var VideoLinearGradient = /*#__PURE__*/ memo(function() {
    return /*#__PURE__*/ _jsx(LinearGradient, {
        colors: [
            'transparent',
            'rgba(0,0,0,0.6)'
        ],
        style: StyleSheet.absoluteFillObject,
        start: [
            0,
            0.75
        ],
        end: [
            0,
            1
        ]
    });
});
function isClosedCaptionAvailableForUri(uri) {
    return typeof uri === 'string' && (isMuxUrl(uri) || uri.match(/voiceover|vignette/));
}
var AccessibleLabelWrapper = function(props) {
    var formatDuration = useFormatDuration().formatDuration;
    var getAccessibleLabel = function(positionMillis, durationMillis) {
        var position = getMinuteSecondFromMillis(positionMillis);
        var duration = getMinuteSecondFromMillis(durationMillis);
        var positionLabel = formatDuration({
            minutes: position.minutes,
            seconds: position.seconds
        });
        var durationLabel = formatDuration({
            minutes: duration.minutes,
            seconds: duration.seconds
        });
        return "".concat(positionLabel, " elapsed of ").concat(durationLabel);
    };
    return props.children({
        getAccessibleLabel: getAccessibleLabel
    });
};
// @ts-ignore
var DEMO_AUDIO = 'http://www.hochmuth.com/mp3/Beethoven_12_Variation.mp3';
// @ts-ignore
var DEMO_VIDEO = 'https://storage.googleapis.com/asset.oui.dev/static/sample.mp4';
function isAudioURI(uri) {
    var _query_contentType;
    if (uri.endsWith('.mp3')) return true;
    if (uri.endsWith('.mp4')) return false;
    var query = new Url(uri, {}, {
        parser: true
    }).query;
    return (_query_contentType = query.contentType) === null || _query_contentType === void 0 ? void 0 : _query_contentType.includes('audio');
}
/**
 * Media playback element for video/audio content.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-90}
 */ export var MediaPlayer = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(MediaPlayer, Component);
    function MediaPlayer() {
        _class_call_check(this, MediaPlayer);
        var _this;
        var _this_props_miniPlayer;
        _this = _call_super(this, MediaPlayer, arguments), _define_property(_this, "context", void 0), _define_property(_this, "controlsOpacity", new Animated.Value(_this.props.hideControls ? 0 : 1)), _define_property(_this, "hideControlsTimeout", 0) // eslint-disable-line
        , _define_property(_this, "keepAwakeTag", "KeepAwake:MediaPlayer:".concat(Math.random())), _define_property(_this, "source", void 0), _define_property(_this, "video", /*#__PURE__*/ createRef()), _define_property(_this, "rnVideo", /*#__PURE__*/ createRef()), _define_property(_this, "isScreenReaderEnabled", false), _define_property(_this, "hls", void 0 // eslint-disable-line
        ), _define_property(_this, "hlsCallback", void 0), _define_property(_this, "appStateChangeListener", void 0), _define_property(_this, "state", {
            durationMillis: 0,
            initialized: false,
            isClosedCaptionEnabled: false,
            isHeightConstrained: false,
            isLoaded: false,
            isMuted: false,
            isPlaying: _this.props.autoPlay || false,
            isShowingControls: !_this.props.hideControls,
            isShowingTranscript: false,
            loadRetryAttempt: 0,
            miniPlayer: (_this_props_miniPlayer = _this.props.miniPlayer) !== null && _this_props_miniPlayer !== void 0 ? _this_props_miniPlayer : isAudioURI(_this.props.uri),
            positionMillis: 0
        }), _define_property(_this, "onVideoRef", function(r) {
            _this.video.current = r;
            var source = _this.props.uri;
            if (Platform.OS === 'web' && r && typeof source === 'string' && source.endsWith('.m3u8')) {
                _this.hlsCallback = function() {
                    var hls = new _this.hls();
                    // @ts-expect-error
                    hls.attachMedia(r._nativeRef.current._video);
                    hls.on(_this.hls.Events.MEDIA_ATTACHED, function() {
                        hls.loadSource(source);
                        var _this1 = _this;
                        hls.on(_this.hls.Events.MANIFEST_PARSED, /*#__PURE__*/ _async_to_generator(function() {
                            return _ts_generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!_this1.props.autoPlay) return [
                                            3,
                                            4
                                        ];
                                        if (!_this1.props.initialPositionMillis) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            r.setPositionAsync(_this1.props.initialPositionMillis)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            4,
                                            r.playAsync()
                                        ];
                                    case 3:
                                        _state.sent();
                                        _state.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                    });
                    _this.hlsCallback = undefined;
                };
                if (_this.hls) _this.hlsCallback();
            }
        }), _define_property(_this, "onFullscreenChange", function(event) {
            var _this_video_current__nativeRef_current, _this_video_current__nativeRef, _this_video_current, _this_video;
            if (!_this.props.onFullscreenUpdate) return;
            // eslint-disable-next-line
            if (event.target === ((_this_video = _this.video) === null || _this_video === void 0 ? void 0 : (_this_video_current = _this_video.current) === null || _this_video_current === void 0 ? void 0 : (_this_video_current__nativeRef = _this_video_current._nativeRef) === null || _this_video_current__nativeRef === void 0 ? void 0 : (_this_video_current__nativeRef_current = _this_video_current__nativeRef.current) === null || _this_video_current__nativeRef_current === void 0 ? void 0 : _this_video_current__nativeRef_current._video)) {
                if (document.fullscreenElement) {
                    // eslint-disable-next-line
                    _this.props.onFullscreenUpdate({
                        fullscreenUpdate: 1
                    });
                } else {
                    // eslint-disable-next-line
                    _this.props.onFullscreenUpdate({
                        fullscreenUpdate: 3
                    });
                }
            }
        }), _define_property(_this, "onAppStateChange", function(nextAppState) {
            // People often expect videos to continue playing when switching tabs on web
            // and this is also currently forcing videos to autopause when fullscreening
            // because the state changes to "background" temporarily.
            // We could do some pause / resume state tracking here to auto play when
            // nextState returns to active but more trouble than it's worth.
            if (nextAppState !== 'active' && Platform.OS !== 'web') {
                void _this.setIsPlayingAsync(false);
            }
        }), _define_property(_this, "toggleControls", function(forceShow) {
            if (_this.state.miniPlayer) {
                if (forceShow) return;
                _this.setState({
                    miniPlayer: false
                });
            } else {
                if (_this.isScreenReaderEnabled || forceShow && _this.state.isShowingControls) return;
                clearTimeout(_this.hideControlsTimeout);
                _this.setState({
                    isShowingControls: !_this.state.isShowingControls
                }, function() {
                    Animated.timing(_this.controlsOpacity, {
                        useNativeDriver: Platform.OS !== 'web',
                        // in the setState callback, isShowingControls will already be updated to the destination state
                        toValue: _this.state.isShowingControls ? 1 : 0
                    }).start();
                });
            }
        });
        return _this;
    }
    _create_class(MediaPlayer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                if (Platform.OS === 'web') {
                    void import("../lib/hls").then(function(result) {
                        var _this_hlsCallback, _this1;
                        _this.hls = result.default;
                        (_this_hlsCallback = (_this1 = _this).hlsCallback) === null || _this_hlsCallback === void 0 ? void 0 : _this_hlsCallback.call(_this1);
                    });
                }
                if (this.state.isPlaying && Platform.OS !== 'web') {
                    void activateKeepAwakeAsync(this.keepAwakeTag);
                }
                void AccessibilityInfo.isScreenReaderEnabled().then(function(isScreenReaderEnabled) {
                    _this.isScreenReaderEnabled = isScreenReaderEnabled;
                    if (isScreenReaderEnabled) {
                        _this.toggleControls(true);
                        clearTimeout(_this.hideControlsTimeout);
                    }
                });
                Sentry.addBreadcrumb({
                    message: 'MediaPlayer uri',
                    data: {
                        uri: this.props.uri
                    }
                });
                this.appStateChangeListener = AppState.addEventListener('change', this.onAppStateChange);
                if (this.props.autoPlay && !this.props.hideControls) {
                    this.hideControlsTimeout = setTimeout(function() {
                        _this.setState({
                            isShowingControls: false
                        });
                        Animated.timing(_this.controlsOpacity, {
                            useNativeDriver: Platform.OS !== 'web',
                            toValue: 0
                        }).start();
                    }, 2000);
                }
                void preloadPersistedState('enableMute').then(function(value) {
                    if (typeof value === 'boolean') {
                        _this.setState({
                            isMuted: value
                        }, function() {
                            if (_this.video.current) {
                                if (_this.state.isMuted) {
                                    void _this.video.current.setIsMutedAsync(false);
                                } else {
                                    void _this.video.current.setIsMutedAsync(true);
                                }
                            }
                        });
                    }
                });
                var _this1 = this;
                void preloadPersistedState('enableClosedCaptions').then(/*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(value) {
                        var volume;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getVolume()
                                    ];
                                case 1:
                                    volume = _state.sent();
                                    if (volume === 0) {
                                        _this1.setState({
                                            isClosedCaptionEnabled: true
                                        });
                                    } else if (typeof value === 'boolean') {
                                        _this1.setState({
                                            isClosedCaptionEnabled: value
                                        });
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(value) {
                        return _ref.apply(this, arguments);
                    };
                }());
                var sourceUri = getCachedUri(this.props.uri);
                if (sourceUri) {
                    void FileSystem.getInfoAsync(sourceUri).then(function(_param) {
                        var exists = _param.exists, rest = _object_without_properties(_param, [
                            "exists"
                        ]);
                        Sentry.addBreadcrumb({
                            message: 'MediaPlayer cache',
                            data: _object_spread({
                                exists: exists
                            }, rest)
                        });
                        if (exists) {
                            _this.source = {
                                uri: sourceUri
                            };
                        }
                        _this.setState({
                            initialized: true
                        });
                    });
                } else {
                    this.setState({
                        initialized: true
                    });
                }
                // https://github.com/expo/expo/pull/6610
                if (Platform.OS === 'web') {
                    // @ts-ignore
                    var isIE11 = !!window['MSStream'];
                    document.addEventListener(isIE11 ? 'MSFullscreenChange' : 'fullscreenchange', this.onFullscreenChange);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this_appStateChangeListener;
                if (this.state.isPlaying && Platform.OS !== 'web') {
                    var // https://github.com/TheWidlarzGroup/react-native-video/issues/2913#issuecomment-1322153725
                    // @ts-expect-error setNativeProps not in types but does exist
                    _this_rnVideo_current_setNativeProps, _this_rnVideo_current;
                    void deactivateKeepAwake(this.keepAwakeTag);
                    (_this_rnVideo_current = this.rnVideo.current) === null || _this_rnVideo_current === void 0 ? void 0 : (_this_rnVideo_current_setNativeProps = _this_rnVideo_current.setNativeProps) === null || _this_rnVideo_current_setNativeProps === void 0 ? void 0 : _this_rnVideo_current_setNativeProps.call(_this_rnVideo_current, {
                        paused: true
                    });
                }
                (_this_appStateChangeListener = this.appStateChangeListener) === null || _this_appStateChangeListener === void 0 ? void 0 : _this_appStateChangeListener.remove();
                clearTimeout(this.hideControlsTimeout);
                if (Platform.OS !== 'web') {
                    void deactivateKeepAwake(this.keepAwakeTag);
                }
                if (Platform.OS === 'web') {
                    // @ts-ignore
                    var isIE11 = !!window['MSStream'];
                    document.addEventListener(isIE11 ? 'MSFullscreenChange' : 'fullscreenchange', this.onFullscreenChange);
                }
            }
        },
        {
            key: "presentFullscreenPlayer",
            value: function presentFullscreenPlayer() {
                var _this = this;
                return _async_to_generator(function() {
                    var ref, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ref = _this.video.current || _this.rnVideo.current;
                                if (!ref) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    ref.presentFullscreenPlayer()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "dismissFullscreenPlayer",
            value: function dismissFullscreenPlayer() {
                var _this = this;
                return _async_to_generator(function() {
                    var ref, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                ref = _this.video.current || _this.rnVideo.current;
                                if (!ref) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    ref.dismissFullscreenPlayer()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setIsPlayingAsync",
            value: function setIsPlayingAsync(isPlaying) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props_onProgress, _this_props;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.video.current) return [
                                    3,
                                    4
                                ];
                                if (!isPlaying) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    catchChromeAutoplayError(function() {
                                        var _this_video_current, _this_video;
                                        return (_this_video = _this.video) === null || _this_video === void 0 ? void 0 : (_this_video_current = _this_video.current) === null || _this_video_current === void 0 ? void 0 : _this_video_current.playAsync();
                                    }, function() {
                                        return _this.setState({
                                            isMuted: true
                                        }, function() {
                                            var _this_video_current;
                                            void ((_this_video_current = _this.video.current) === null || _this_video_current === void 0 ? void 0 : _this_video_current.setIsMutedAsync(true).then(function() {
                                                return _this.setIsPlayingAsync(true);
                                            }));
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.video.current.pauseAsync()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _this.setState({
                                    isPlaying: isPlaying
                                });
                                if (!isPlaying) {
                                    ;
                                    (_this_props_onProgress = (_this_props = _this.props).onProgress) === null || _this_props_onProgress === void 0 ? void 0 : _this_props_onProgress.call(_this_props, {
                                        positionMillis: _this.state.positionMillis,
                                        durationMillis: _this.state.durationMillis
                                    }, isPlaying);
                                }
                                if (Platform.OS !== 'web') {
                                    if (isPlaying) {
                                        void activateKeepAwakeAsync(_this.keepAwakeTag);
                                    } else {
                                        void deactivateKeepAwake(_this.keepAwakeTag);
                                    }
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setPositionAsync",
            value: function setPositionAsync(positionMillis) {
                if (this.video.current) {
                    void this.video.current.setPositionAsync(positionMillis);
                } else if (this.rnVideo.current) {
                    // Some videos dont handle seeking to the very last timestamp, so make sure we safely seek
                    // to a time in between [start, end)
                    var seekSeconds = Math.min(positionMillis, this.state.durationMillis) / 1000;
                    this.rnVideo.current.seek(Math.max(seekSeconds - 0.01, 0));
                }
                this.setState({
                    positionMillis: positionMillis
                });
            }
        },
        {
            key: "renderVolumeButton",
            value: function renderVolumeButton() {
                var _this = this;
                return /*#__PURE__*/ _jsx(View, {
                    children: /*#__PURE__*/ _jsx(Icon, {
                        "aria-label": this.state.isMuted ? 'Unmute' : 'Mute',
                        color: this.state.miniPlayer ? this.props.miniPlayerControlsColor : 'white',
                        name: this.state.isMuted ? 'audio-mute' : 'audio',
                        size: 20,
                        onPress: function() {
                            if (_this.video.current) {
                                if (_this.state.isMuted) {
                                    void _this.video.current.setIsMutedAsync(false);
                                } else {
                                    void _this.video.current.setIsMutedAsync(true);
                                }
                            }
                            setPersistedState('enableMute', !_this.state.isMuted);
                            _this.setState({
                                isMuted: !_this.state.isMuted
                            });
                        }
                    })
                });
            }
        },
        {
            key: "renderClosedCaptionsToggle",
            value: function renderClosedCaptionsToggle() {
                var _this = this;
                return /*#__PURE__*/ _jsxs(View, {
                    row: true,
                    spacing: 14,
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            "aria-label": this.state.isClosedCaptionEnabled ? 'Disable captions' : 'Enable captions',
                            color: "white",
                            name: this.state.isClosedCaptionEnabled ? 'closed-captioning-selected' : 'closed-captioning',
                            size: 20,
                            onPress: function() {
                                setPersistedState('enableClosedCaptions', !_this.state.isClosedCaptionEnabled);
                                _this.setState({
                                    isClosedCaptionEnabled: !_this.state.isClosedCaptionEnabled
                                });
                            }
                        }),
                        this.renderShowTranscriptButton()
                    ]
                });
            }
        },
        {
            key: "renderShowTranscriptButton",
            value: function renderShowTranscriptButton() {
                var _this = this;
                return /*#__PURE__*/ _jsx(View, {
                    children: /*#__PURE__*/ _jsx(Icon, {
                        "aria-label": "Show transcript",
                        color: "white",
                        name: "transcript",
                        size: 20,
                        onPress: function() {
                            _this.setState({
                                isShowingTranscript: true
                            });
                        }
                    })
                });
            }
        },
        {
            key: "renderMiniPlayerToggle",
            value: function renderMiniPlayerToggle() {
                var _this = this;
                return /*#__PURE__*/ _jsx(View, {
                    children: /*#__PURE__*/ _jsx(Icon, {
                        "aria-label": this.state.miniPlayer ? 'Maximize player' : 'Minimize player',
                        color: this.state.miniPlayer ? this.props.miniPlayerControlsColor : 'white',
                        name: this.state.miniPlayer ? 'expand' : 'collapse',
                        size: 20,
                        onPress: function() {
                            _this.setState({
                                miniPlayer: !_this.state.miniPlayer
                            });
                        }
                    })
                });
            }
        },
        {
            key: "renderPlayPauseButton",
            value: function renderPlayPauseButton() {
                var _this = this;
                return /*#__PURE__*/ _jsx(View, {
                    children: /*#__PURE__*/ _jsx(Icon, {
                        testID: this.state.isPlaying ? 'MediaPlayer_pauseButton' : 'MediaPlayer_playButton',
                        "aria-label": this.state.isPlaying ? 'Pause' : 'Play',
                        color: this.state.miniPlayer ? this.props.miniPlayerControlsColor : 'white',
                        name: this.state.isPlaying ? 'pause' : 'play',
                        size: 20,
                        onPress: function() {
                            if (!_this.state.isPlaying && _this.state.durationMillis === _this.state.positionMillis) {
                                _this.setPositionAsync(0);
                                void _this.setIsPlayingAsync(true);
                            } else {
                                void _this.setIsPlayingAsync(!_this.state.isPlaying);
                            }
                        }
                    })
                });
            }
        },
        {
            key: "isAudio",
            value: function isAudio() {
                return typeof this.props.uri === 'number' || this.props.isAudio || isAudioURI(this.props.uri);
            }
        },
        {
            key: "renderVideo",
            value: function renderVideo() {
                var _this = this;
                var isAudio = this.isAudio();
                var _this_props_headers, _this_source;
                var source = (_this_source = this.source) !== null && _this_source !== void 0 ? _this_source : typeof this.props.uri === 'number' ? this.props.uri : {
                    uri: this.props.uri,
                    headers: (_this_props_headers = this.props.headers) !== null && _this_props_headers !== void 0 ? _this_props_headers : {}
                };
                var style = [
                    {
                        backgroundColor: isAudio ? 'transparent' : this.props.backgroundColor
                    },
                    this.state.miniPlayer ? {
                        height: '100%'
                    } : {
                        height: '100%',
                        width: '100%'
                    },
                    isAudio ? {
                        height: 0,
                        width: 0
                    } : null
                ];
                var _this1 = this;
                var onError = /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function(errorString) {
                        var _this_props_onError, _this_props, canReattempt, isConnected, _this_source;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    canReattempt = _this1.state.loadRetryAttempt < MAX_RETRY_ATTEMPTS;
                                    return [
                                        4,
                                        fetchIsConnected()
                                    ];
                                case 1:
                                    isConnected = _state.sent();
                                    if (!canReattempt) return [
                                        3,
                                        4
                                    ];
                                    Sentry.withScope(function(scope) {
                                        scope.setExtras({
                                            cachedSource: _this1.source,
                                            isConnected: isConnected,
                                            loadRetryAttempt: _this1.state.loadRetryAttempt,
                                            MAX_RETRY_ATTEMPTS: MAX_RETRY_ATTEMPTS
                                        });
                                        Sentry.captureMessage("MediaPlayer error: ".concat(errorString), 'warning');
                                    });
                                    if (!((_this_source = _this1.source) === null || _this_source === void 0 ? void 0 : _this_source.uri)) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        FileSystem.deleteAsync(_this1.source.uri)
                                    ];
                                case 2:
                                    _state.sent();
                                    _this1.source = undefined;
                                    _state.label = 3;
                                case 3:
                                    setTimeout(function() {
                                        _this1.setState({
                                            loadRetryAttempt: _this1.state.loadRetryAttempt + 1
                                        });
                                    }, _this1.state.loadRetryAttempt * 100);
                                    // return so we don't bubble the error up until our reattempts have been exhausted
                                    return [
                                        2
                                    ];
                                case 4:
                                    Sentry.withScope(function(scope) {
                                        scope.setExtras({
                                            isConnected: isConnected
                                        });
                                        Sentry.captureException(errorString);
                                    });
                                    (_this_props_onError = (_this_props = _this1.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function onError(errorString) {
                        return _ref.apply(this, arguments);
                    };
                }();
                if (!this.state.initialized) return null;
                if (Platform.OS !== 'web') {
                    var _this_context_data_user_role, _this_context_data_user, _this_context_data, _this_context_data1, _this_context_data2, _this_context_data3, _this_context_data4;
                    var _this_props_resizeMode, _this_props_title;
                    return /*#__PURE__*/ _jsx(MuxVideo, {
                        accessible: false,
                        "aria-hidden": true,
                        ref: this.rnVideo,
                        resizeMode: (_this_props_resizeMode = this.props.resizeMode) !== null && _this_props_resizeMode !== void 0 ? _this_props_resizeMode : 'contain',
                        poster: typeof this.props.posterSource === 'string' ? this.props.posterSource : undefined,
                        disableFocus: true,
                        mixWithOthers: "mix",
                        paused: !this.state.isPlaying,
                        ignoreSilentSwitch: "ignore",
                        muted: this.state.isMuted,
                        rate: APP_SLUG === 'ptsd' ? ((_this_context_data = this.context.data) === null || _this_context_data === void 0 ? void 0 : (_this_context_data_user = _this_context_data.user) === null || _this_context_data_user === void 0 ? void 0 : (_this_context_data_user_role = _this_context_data_user.role) === null || _this_context_data_user_role === void 0 ? void 0 : _this_context_data_user_role.productStatic) ? undefined : 0.75 : undefined,
                        source: source,
                        bufferConfig: // android suffers from OOM during QuizSet e2e tests which are video heavy. To try to
                        // mitigate that issue, we'll cap the video buffering
                        global.e2e && Platform.OS === 'android' ? {
                            minBufferMs: 500,
                            maxBufferMs: 2000,
                            bufferForPlaybackMs: 500,
                            bufferForPlaybackAfterRebufferMs: 500
                        } : undefined,
                        selectedTextTrack: isClosedCaptionAvailableForUri(this.props.uri) && this.state.isClosedCaptionEnabled ? {
                            type: SelectedTrackType.INDEX,
                            value: 0
                        } : undefined,
                        textTracks: isClosedCaptionAvailableForUri(this.props.uri) && // mux includes captions in m3u8 manifest file
                        !isMuxUrl(this.props.uri) ? [
                            {
                                title: 'English Subtitles',
                                language: 'en',
                                type: TextTrackType.VTT,
                                uri: this.props.uri.replace('.mp4', '.vtt')
                            }
                        ] : undefined,
                        style: style,
                        onLoad: function(data) {
                            var _this_props_onLoad, _this_props;
                            Sentry.addBreadcrumb({
                                message: 'MediaPlayer (RNVideo) onLoad',
                                data: data
                            });
                            var _data_currentTime, _this_props_initialPositionMillis;
                            var positionMillis = (_this_props_initialPositionMillis = _this.props.initialPositionMillis) !== null && _this_props_initialPositionMillis !== void 0 ? _this_props_initialPositionMillis : ((_data_currentTime = data.currentTime) !== null && _data_currentTime !== void 0 ? _data_currentTime : 0) * 1000;
                            if (_this.props.initialPositionMillis) {
                                _this.setPositionAsync(_this.props.initialPositionMillis);
                            }
                            _this.setState({
                                isLoaded: true,
                                durationMillis: data.duration * 1000,
                                positionMillis: positionMillis
                            });
                            (_this_props_onLoad = (_this_props = _this.props).onLoad) === null || _this_props_onLoad === void 0 ? void 0 : _this_props_onLoad.call(_this_props);
                        },
                        onBuffer: function(param) {
                            var isBuffering = param.isBuffering;
                            Sentry.addBreadcrumb({
                                message: 'MediaPlayer on Buffer',
                                data: {
                                    isBuffering: isBuffering
                                }
                            });
                            _this.setState({
                                isLoaded: !isBuffering
                            });
                        },
                        onProgress: function(param) {
                            var currentTime = param.currentTime;
                            var _this_props_onProgress, _this_props;
                            var positionMillis = currentTime * 1000;
                            _this.setState({
                                positionMillis: positionMillis
                            });
                            (_this_props_onProgress = (_this_props = _this.props).onProgress) === null || _this_props_onProgress === void 0 ? void 0 : _this_props_onProgress.call(_this_props, {
                                positionMillis: positionMillis,
                                durationMillis: _this.state.durationMillis
                            }, _this.state.isPlaying);
                        },
                        onError: function(result) {
                            var _result_error_errorString;
                            void onError((_result_error_errorString = result.error.errorString) !== null && _result_error_errorString !== void 0 ? _result_error_errorString : JSON.stringify(result.error));
                        },
                        onEnd: function() {
                            var _this_props_onEnd, _this_props;
                            Sentry.addBreadcrumb({
                                message: 'MediaPlayer onEnd',
                                data: {
                                    isPlaying: _this.state.isPlaying,
                                    positionMillis: _this.state.positionMillis,
                                    durationMillis: _this.state.durationMillis
                                }
                            });
                            _this.setState({
                                isPlaying: false,
                                positionMillis: _this.state.durationMillis
                            });
                            (_this_props_onEnd = (_this_props = _this.props).onEnd) === null || _this_props_onEnd === void 0 ? void 0 : _this_props_onEnd.call(_this_props);
                        },
                        onFullscreenPlayerWillPresent: function() {
                            var _this_props_onFullscreenUpdate, _this_props;
                            var fullscreenUpdate = VideoFullscreenUpdate.PLAYER_WILL_PRESENT;
                            (_this_props_onFullscreenUpdate = (_this_props = _this.props).onFullscreenUpdate) === null || _this_props_onFullscreenUpdate === void 0 ? void 0 : _this_props_onFullscreenUpdate.call(_this_props, {
                                fullscreenUpdate: fullscreenUpdate
                            });
                        },
                        onFullscreenPlayerWillDismiss: function() {
                            var _this_props_onFullscreenUpdate, _this_props;
                            var fullscreenUpdate = VideoFullscreenUpdate.PLAYER_WILL_DISMISS;
                            (_this_props_onFullscreenUpdate = (_this_props = _this.props).onFullscreenUpdate) === null || _this_props_onFullscreenUpdate === void 0 ? void 0 : _this_props_onFullscreenUpdate.call(_this_props, {
                                fullscreenUpdate: fullscreenUpdate
                            });
                        },
                        onFullscreenPlayerDidPresent: function() {
                            var _this_props_onFullscreenUpdate, _this_props;
                            var fullscreenUpdate = VideoFullscreenUpdate.PLAYER_DID_PRESENT;
                            (_this_props_onFullscreenUpdate = (_this_props = _this.props).onFullscreenUpdate) === null || _this_props_onFullscreenUpdate === void 0 ? void 0 : _this_props_onFullscreenUpdate.call(_this_props, {
                                fullscreenUpdate: fullscreenUpdate
                            });
                        },
                        onFullscreenPlayerDidDismiss: function() {
                            var _this_props_onFullscreenUpdate, _this_props;
                            var fullscreenUpdate = VideoFullscreenUpdate.PLAYER_DID_DISMISS;
                            (_this_props_onFullscreenUpdate = (_this_props = _this.props).onFullscreenUpdate) === null || _this_props_onFullscreenUpdate === void 0 ? void 0 : _this_props_onFullscreenUpdate.call(_this_props, {
                                fullscreenUpdate: fullscreenUpdate
                            });
                        },
                        muxOptions: {
                            application_name: APP_SLUG,
                            application_version: manifest.version,
                            data: {
                                viewer_user_id: ((_this_context_data1 = this.context.data) === null || _this_context_data1 === void 0 ? void 0 : _this_context_data1.user) ? getUserIDForThirdParties({
                                    userID: (_this_context_data2 = this.context.data) === null || _this_context_data2 === void 0 ? void 0 : _this_context_data2.user.ID,
                                    username: (_this_context_data3 = this.context.data) === null || _this_context_data3 === void 0 ? void 0 : _this_context_data3.user.username,
                                    createdAt: (_this_context_data4 = this.context.data) === null || _this_context_data4 === void 0 ? void 0 : _this_context_data4.user.createdAt
                                }) : undefined,
                                env_key: MUX_ENV_KEY,
                                video_id: this.props.uri.split('/').reverse()[0],
                                video_title: (_this_props_title = this.props.title) !== null && _this_props_title !== void 0 ? _this_props_title : this.props.uri.split('/').reverse()[0]
                            }
                        }
                    }, this.state.loadRetryAttempt.toString());
                }
                var _this_props_resizeMode1;
                return /*#__PURE__*/ _jsx(Video, {
                    ref: this.onVideoRef,
                    resizeMode: (_this_props_resizeMode1 = this.props.resizeMode) !== null && _this_props_resizeMode1 !== void 0 ? _this_props_resizeMode1 : ResizeMode.CONTAIN,
                    posterSource: this.props.posterSource,
                    posterStyle: this.props.posterSource ? {
                        width: '100%',
                        height: '100%'
                    } : undefined,
                    usePoster: !!this.props.posterSource,
                    onFullscreenUpdate: this.props.onFullscreenUpdate,
                    shouldPlay: this.props.autoPlay,
                    source: source,
                    // NB This prop doesn't appear to be respected on web. We implement this for hls playback
                    // in onVideoRef
                    status: {
                        positionMillis: this.props.initialPositionMillis || 0
                    },
                    style: style,
                    videoStyle: {
                        height: '100%',
                        width: '100%'
                    },
                    onLoad: function(status) {
                        var _this_props_onLoad, _this_props;
                        Sentry.addBreadcrumb({
                            message: 'MediaPlayer onLoad',
                            data: status
                        });
                        (_this_props_onLoad = (_this_props = _this.props).onLoad) === null || _this_props_onLoad === void 0 ? void 0 : _this_props_onLoad.call(_this_props);
                    },
                    onPlaybackStatusUpdate: function(status) {
                        if (status.isLoaded) {
                            var _this_props_onProgress, _this_props;
                            if (Platform.OS !== 'web') {
                                if (status.isPlaying && !_this.state.isPlaying) {
                                    void activateKeepAwakeAsync(_this.keepAwakeTag);
                                } else if (!status.isPlaying && _this.state.isPlaying) {
                                    void deactivateKeepAwake(_this.keepAwakeTag);
                                }
                            }
                            _this.setState({
                                durationMillis: status.durationMillis || 0,
                                isLoaded: true,
                                isMuted: status.isMuted,
                                isPlaying: status.isPlaying,
                                positionMillis: status.positionMillis || 0
                            });
                            var _status_positionMillis, _status_durationMillis;
                            (_this_props_onProgress = (_this_props = _this.props).onProgress) === null || _this_props_onProgress === void 0 ? void 0 : _this_props_onProgress.call(_this_props, {
                                positionMillis: (_status_positionMillis = status.positionMillis) !== null && _status_positionMillis !== void 0 ? _status_positionMillis : 0,
                                durationMillis: (_status_durationMillis = status.durationMillis) !== null && _status_durationMillis !== void 0 ? _status_durationMillis : 0
                            }, status.isPlaying);
                            if (status.didJustFinish) {
                                var _this_props_onEnd, _this_props1;
                                Sentry.addBreadcrumb({
                                    message: 'MediaPlayer onEnd (didJustFinish)'
                                });
                                (_this_props_onEnd = (_this_props1 = _this.props).onEnd) === null || _this_props_onEnd === void 0 ? void 0 : _this_props_onEnd.call(_this_props1);
                            }
                        } else if (status.error) {
                            void onError(status.error);
                        }
                    }
                }, this.state.loadRetryAttempt.toString());
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var textStyle = this.state.miniPlayer ? {
                    color: this.props.miniPlayerControlsColor
                } : {
                    color: 'white',
                    textShadowColor: 'black',
                    textShadowOffset: {
                        width: 0,
                        height: 0
                    },
                    textShadowRadius: 2
                };
                var isAudio = this.isAudio();
                var _this_props_aspectRatio;
                var aspectRatio = this.props.aspectRatio !== null ? (_this_props_aspectRatio = this.props.aspectRatio) !== null && _this_props_aspectRatio !== void 0 ? _this_props_aspectRatio : isAudio ? 1 : this.props.uri.toString().includes('v1_1') ? 9 / 16 : 16 / 9 : null;
                var _this_props_subtitleUri;
                return /*#__PURE__*/ _jsxs(View, {
                    onLayout: aspectRatio === null ? undefined : function(event) {
                        var layout = event.nativeEvent.layout;
                        var isHeightConstrained = layout.width / layout.height > aspectRatio + 0.05; // tolerance
                        if (isHeightConstrained !== _this.state.isHeightConstrained) {
                            _this.setState({
                                isHeightConstrained: isHeightConstrained
                            });
                        }
                    },
                    row: true,
                    style: {
                        height: this.state.miniPlayer ? 70 : undefined,
                        minHeight: 70,
                        width: '100%'
                    },
                    children: [
                        this.state.isLoaded ? null : /*#__PURE__*/ _jsx(View, {
                            pointerEvents: "none",
                            style: [
                                StyleSheet.absoluteFillObject,
                                {
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 1
                                }
                            ],
                            children: /*#__PURE__*/ _jsx(ActivityIndicator, {})
                        }),
                        /*#__PURE__*/ _jsxs(TouchableOpacity, {
                            testID: "MediaPlayer_videoContainer",
                            activeOpacity: 1,
                            disabled: this.props.hideControls,
                            style: {
                                flexGrow: this.state.miniPlayer ? 0 : 1,
                                maxWidth: '100%',
                                backgroundColor: this.props.backgroundColor,
                                alignItems: this.state.isHeightConstrained ? 'center' : undefined
                            },
                            onPress: function() {
                                return _this.toggleControls();
                            },
                            accessible: false,
                            importantForAccessibility: "no",
                            children: [
                                aspectRatio === null ? this.renderVideo() : /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        aspectRatio: aspectRatio
                                    },
                                    children: this.renderVideo()
                                }),
                                this.props.subtitleUri ? /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        position: 'absolute',
                                        right: 10,
                                        left: 10,
                                        bottom: 50
                                    },
                                    children: /*#__PURE__*/ _jsx(Subtitles, {
                                        positionMillis: this.state.positionMillis,
                                        uri: this.props.subtitleUri,
                                        enabled: this.state.isClosedCaptionEnabled
                                    })
                                }) : null,
                                !this.state.miniPlayer ? /*#__PURE__*/ _jsx(Animated.View, {
                                    style: [
                                        StyleSheet.absoluteFillObject,
                                        {
                                            opacity: this.controlsOpacity
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(VideoLinearGradient, {})
                                }) : null
                            ]
                        }),
                        this.props._enableSkipToEnd ? /*#__PURE__*/ _jsx(View, {
                            style: {
                                position: 'absolute',
                                top: 5,
                                left: 5,
                                // for android
                                zIndex: 5
                            },
                            testID: "MediaPlayer_skipToEnd",
                            children: /*#__PURE__*/ _jsx(Icon, {
                                "aria-label": "Skip",
                                color: "rgba(0,0,0,0.6)",
                                name: "skip-in-session",
                                size: 20,
                                onPress: function() {
                                    void _this.setIsPlayingAsync(false).catch().then(function() {
                                        var _this_props_onEnd, _this_props;
                                        return (_this_props_onEnd = (_this_props = _this.props).onEnd) === null || _this_props_onEnd === void 0 ? void 0 : _this_props_onEnd.call(_this_props);
                                    });
                                }
                            })
                        }) : null,
                        !this.state.miniPlayer ? /*#__PURE__*/ _jsx(Animated.View, {
                            pointerEvents: this.state.isShowingControls ? 'box-none' : 'none',
                            style: {
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                opacity: this.controlsOpacity,
                                backgroundColor: 'rgba(255,255,255,0.3)',
                                borderRadius: 50
                            },
                            children: this.props.onClose ? /*#__PURE__*/ _jsx(Icon, {
                                "aria-label": "Close",
                                color: "rgba(0,0,0,0.6)",
                                name: "close",
                                size: 20,
                                onPress: this.props.onClose
                            }) : null
                        }) : null,
                        /*#__PURE__*/ _jsxs(Animated.View, {
                            pointerEvents: this.state.isShowingControls || this.state.miniPlayer ? 'box-none' : 'none',
                            style: [
                                {
                                    opacity: this.state.miniPlayer ? 1 : this.controlsOpacity,
                                    padding: this.state.miniPlayer ? 12 : 6,
                                    flex: 1,
                                    justifyContent: 'space-between'
                                },
                                this.state.miniPlayer ? null : {
                                    position: 'absolute',
                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0
                                }
                            ],
                            children: [
                                this.props.title ? /*#__PURE__*/ _jsx(Text, {
                                    text: this.props.title,
                                    weight: "bold",
                                    size: 20,
                                    style: textStyle
                                }) : /*#__PURE__*/ _jsx(View, {}),
                                this.props.hideControls ? null : /*#__PURE__*/ _jsxs(View, {
                                    row: true,
                                    spacing: 14,
                                    style: this.props.controlsContainerStyle,
                                    children: [
                                        this.state.miniPlayer || this.props._hidePlayPauseButton ? null : this.renderPlayPauseButton(),
                                        /*#__PURE__*/ _jsx(Text, {
                                            role: "none",
                                            style: textStyle,
                                            text: getMMSSFromMillis(this.state.positionMillis, this.state.durationMillis),
                                            size: 12
                                        }),
                                        /*#__PURE__*/ _jsx(View, {
                                            style: {
                                                flex: 1
                                            },
                                            children: /*#__PURE__*/ _jsx(AccessibleLabelWrapper, {
                                                children: function(param) {
                                                    var getAccessibleLabel = param.getAccessibleLabel;
                                                    return /*#__PURE__*/ _jsx(View, {
                                                        children: /*#__PURE__*/ _jsx(WithTheme, {
                                                            children: function(param) {
                                                                var theme = param.theme;
                                                                return /*#__PURE__*/ _jsx(Slider, {
                                                                    style: {
                                                                        height: 20
                                                                    },
                                                                    animateTransitions: true,
                                                                    accessible: true,
                                                                    "aria-label": getAccessibleLabel(_this.state.positionMillis, _this.state.durationMillis),
                                                                    role: "slider",
                                                                    accessibilityActions: [
                                                                        {
                                                                            name: 'increment',
                                                                            label: 'increment'
                                                                        },
                                                                        {
                                                                            name: 'decrement',
                                                                            label: 'decrement'
                                                                        }
                                                                    ],
                                                                    onAccessibilityAction: function(event) {
                                                                        switch(event.nativeEvent.actionName){
                                                                            case 'increment':
                                                                                {
                                                                                    var newValue = Math.min(_this.state.positionMillis + 10000, _this.state.durationMillis);
                                                                                    _this.setPositionAsync(newValue);
                                                                                    if (!_this.state.isPlaying) {
                                                                                        _this.setState({
                                                                                            positionMillis: newValue
                                                                                        });
                                                                                    }
                                                                                    if (Platform.OS === 'ios') {
                                                                                        AccessibilityInfo.announceForAccessibility('seeked forward');
                                                                                    }
                                                                                    break;
                                                                                }
                                                                            case 'decrement':
                                                                                {
                                                                                    var newValue1 = Math.max(_this.state.positionMillis - 10000, 0);
                                                                                    _this.setPositionAsync(newValue1);
                                                                                    if (Platform.OS === 'ios') {
                                                                                        AccessibilityInfo.announceForAccessibility('seeked backward');
                                                                                    }
                                                                                    break;
                                                                                }
                                                                        }
                                                                    },
                                                                    disabled: false,
                                                                    minimumValue: 0,
                                                                    maximumValue: _this.state.durationMillis,
                                                                    minimumTrackTintColor: _this.state.miniPlayer ? theme.color.primary100 : 'white',
                                                                    maximumTrackTintColor: _this.state.miniPlayer ? hexToRgba(theme.color.primary100, 0.3) : 'rgba(255,255,255, 0.3)',
                                                                    value: _this.state.positionMillis,
                                                                    thumbStyle: [
                                                                        {
                                                                            width: 10,
                                                                            height: 10,
                                                                            backgroundColor: 'white'
                                                                        },
                                                                        Shadow.default
                                                                    ],
                                                                    onValueChange: noop,
                                                                    onSlidingComplete: function(v) {
                                                                        return _this.setPositionAsync(v);
                                                                    }
                                                                });
                                                            }
                                                        })
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            role: "none",
                                            style: textStyle,
                                            text: getMMSSFromMillis(this.state.durationMillis, this.state.durationMillis),
                                            size: 12
                                        }),
                                        this.state.miniPlayer ? null : this.renderVolumeButton(),
                                        this.state.miniPlayer ? null : this.props.subtitleUri || isClosedCaptionAvailableForUri(this.props.uri) ? this.renderClosedCaptionsToggle() : this.props.allowMini ? this.renderMiniPlayerToggle() : null
                                    ]
                                })
                            ]
                        }),
                        this.state.miniPlayer ? /*#__PURE__*/ _jsxs(View, {
                            row: true,
                            spacing: 14,
                            style: {
                                padding: 12
                            },
                            children: [
                                this.props._hidePlayPauseButton ? null : this.renderPlayPauseButton(),
                                this.renderVolumeButton()
                            ]
                        }) : null,
                        this.state.isShowingTranscript ? /*#__PURE__*/ _jsx(TranscriptModal, {
                            uri: (_this_props_subtitleUri = this.props.subtitleUri) !== null && _this_props_subtitleUri !== void 0 ? _this_props_subtitleUri : isMuxUrl(this.props.uri) ? this.props.uri : this.props.uri.replace('.mp4', '.vtt'),
                            onRequestClose: function() {
                                return _this.setState({
                                    isShowingTranscript: false
                                });
                            }
                        }) : null
                    ]
                });
            }
        }
    ]);
    return MediaPlayer;
}(Component);
_define_property(MediaPlayer, "defaultProps", {
    uri: DEMO_VIDEO,
    autoPlay: true,
    allowMini: true,
    miniPlayerControlsColor: 'black',
    backgroundColor: 'black'
});
_define_property(MediaPlayer, "contextType", CurrentUserContext);
var posterCache = {};
function getPosterCacheKey(param) {
    var uri = param.uri, _param_initialPositionMillis = param.initialPositionMillis, initialPositionMillis = _param_initialPositionMillis === void 0 ? 0 : _param_initialPositionMillis;
    return "".concat(uri, "::").concat(initialPositionMillis);
}
/**
 * Media playback element that renders a thumbnail for the provided content.
 * Upon pressing, opens a fullscreened `MediaPlayer`.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-94}
 */ export var FullscreenMediaPlayer = /*#__PURE__*/ forwardRef(function(props, ref) {
    var theme = useTheme().theme;
    var _useState = _sliced_to_array(useState(false), 2), isSimulatorFullscreen = _useState[0], setIsSimulatorFullscreen = _useState[1];
    var player = useRef(null);
    var useBuiltInFullscreenPlayer = Platform.OS === 'web'; // Device.isDevice; https://github.com/ouihealth/oui/issues/605
    var _posterCache_getPosterCacheKey;
    var _useState1 = _sliced_to_array(useState((_posterCache_getPosterCacheKey = posterCache[getPosterCacheKey(props)]) !== null && _posterCache_getPosterCacheKey !== void 0 ? _posterCache_getPosterCacheKey : ''), 2), previewUri = _useState1[0], setPreviewUri = _useState1[1];
    useImperativeHandle(ref, function() {
        return player.current;
    });
    useEffect(function() {
        var generateThumbnail = function generateThumbnail() {
            return _generateThumbnail.apply(this, arguments);
        };
        function _generateThumbnail() {
            _generateThumbnail = _async_to_generator(function() {
                var allowCache, _props_posterInitialPositionMillis, cacheKey, cacheExists, cachedUri, cacheFileResult, e, thumbnailSourceUri, _props_posterInitialPositionMillis1, _ref, result, e1;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            allowCache = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : true;
                            cacheKey = getPosterCacheKey({
                                uri: props.uri,
                                initialPositionMillis: (_props_posterInitialPositionMillis = props.posterInitialPositionMillis) !== null && _props_posterInitialPositionMillis !== void 0 ? _props_posterInitialPositionMillis : props.initialPositionMillis
                            });
                            if (Platform.OS === 'web') {
                                setPreviewUri(props.uri);
                                return [
                                    2
                                ];
                            }
                            if (!!posterCache[cacheKey]) return [
                                3,
                                8
                            ];
                            cacheExists = false;
                            cachedUri = getCachedUri(props.uri);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                7,
                                ,
                                8
                            ]);
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                FileSystem.getInfoAsync(cachedUri)
                            ];
                        case 3:
                            cacheFileResult = _state.sent();
                            cacheExists = cacheFileResult.exists;
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            Sentry.captureException(e);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            thumbnailSourceUri = cacheExists && allowCache ? cachedUri : props.uri;
                            return [
                                4,
                                VideoThumbnails.getThumbnailAsync(thumbnailSourceUri, {
                                    time: (_ref = (_props_posterInitialPositionMillis1 = props.posterInitialPositionMillis) !== null && _props_posterInitialPositionMillis1 !== void 0 ? _props_posterInitialPositionMillis1 : props.initialPositionMillis) !== null && _ref !== void 0 ? _ref : 0
                                })
                            ];
                        case 6:
                            result = _state.sent();
                            posterCache[cacheKey] = result.uri;
                            setPreviewUri(result.uri);
                            return [
                                3,
                                8
                            ];
                        case 7:
                            e1 = _state.sent();
                            Sentry.withScope(function(scope) {
                                scope.setExtras({
                                    cacheFileResult: cacheFileResult,
                                    cacheExists: cacheExists,
                                    cachedUri: cachedUri,
                                    uri: props.uri
                                });
                                Sentry.captureException(e1);
                            });
                            if (cacheExists) {
                                void generateThumbnail(false);
                            }
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return _generateThumbnail.apply(this, arguments);
        }
        if (isMuxUrl(props.uri)) {
            setPreviewUri(getMuxThumbnail(props.uri, {
                width: null,
                height: null,
                format: 'jpg',
                getPixelSizeForLayoutSize: PixelRatio.getPixelSizeForLayoutSize
            }));
        } else if (!isAudioURI(props.uri)) {
            void generateThumbnail();
        }
    }, [
        props.uri,
        props.initialPositionMillis,
        props.posterInitialPositionMillis
    ]);
    var _props_previewAspectRatio, _props_posterSource, _props_posterSource1;
    return /*#__PURE__*/ _jsx(TouchableOpacity, {
        testID: props.testID,
        style: {
            borderWidth: 1,
            borderColor: theme.color.gray600,
            borderRadius: props.borderRadius
        },
        onPress: function() {
            var press = function press() {
                return _press.apply(this, arguments);
            };
            function _press() {
                _press = _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!useBuiltInFullscreenPlayer) return [
                                    3,
                                    4
                                ];
                                if (!player.current) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    player.current.presentFullscreenPlayer()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    player.current.setIsPlayingAsync(true)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                setIsSimulatorFullscreen(true);
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return _press.apply(this, arguments);
            }
            void press();
        },
        children: /*#__PURE__*/ _jsxs(View, {
            pointerEvents: "none",
            children: [
                !useBuiltInFullscreenPlayer && isSimulatorFullscreen ? /*#__PURE__*/ _jsxs(Modal, {
                    visible: true,
                    onRequestClose: function() {
                        return setIsSimulatorFullscreen(false);
                    },
                    children: [
                        /*#__PURE__*/ _jsx(SystemBars, {
                            style: "light"
                        }),
                        /*#__PURE__*/ _jsxs(TouchableOpacity, {
                            accessible: false,
                            importantForAccessibility: "no",
                            activeOpacity: 1,
                            style: {
                                flex: 1,
                                justifyContent: 'center',
                                backgroundColor: 'black'
                            },
                            onPress: function() {
                                return setIsSimulatorFullscreen(false);
                            },
                            children: [
                                /*#__PURE__*/ _jsx(SafeAreaView, {
                                    style: [
                                        {
                                            backgroundColor: 'rgba(0,0,0,0.6)'
                                        },
                                        isSimulatorFullscreen ? undefined : {
                                            position: 'absolute',
                                            bottom: 0,
                                            right: 0,
                                            left: 0
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(View, {
                                        style: {
                                            padding: 10,
                                            alignItems: 'flex-start'
                                        },
                                        children: /*#__PURE__*/ _jsx(Icon, {
                                            "aria-label": "Exit fullscreen",
                                            name: "close",
                                            onPress: function() {
                                                return setIsSimulatorFullscreen(false);
                                            },
                                            color: "white"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx(SafeAreaView, {
                                    style: {
                                        flex: 1
                                    },
                                    children: /*#__PURE__*/ _jsx(TouchableOpacity, {
                                        accessible: false,
                                        "aria-label": undefined,
                                        role: undefined,
                                        activeOpacity: 1,
                                        style: {
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flex: isSimulatorFullscreen ? 1 : undefined
                                        },
                                        children: /*#__PURE__*/ _jsx(MediaPlayer, {
                                            aspectRatio: props.mediaAspectRatio,
                                            uri: props.uri,
                                            allowMini: false,
                                            autoPlay: true,
                                            hideControls: false,
                                            onEnd: function() {
                                                return setIsSimulatorFullscreen(false);
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        props.caption ? /*#__PURE__*/ _jsx(SafeAreaView, {
                            style: [
                                {
                                    backgroundColor: 'black'
                                },
                                isSimulatorFullscreen ? undefined : {
                                    position: 'absolute',
                                    bottom: 0,
                                    right: 0,
                                    left: 0
                                }
                            ],
                            children: /*#__PURE__*/ _jsx(ScrollView, {
                                style: {
                                    maxHeight: 150
                                },
                                contentContainerStyle: {
                                    padding: 10
                                },
                                children: typeof props.caption === 'string' ? /*#__PURE__*/ _jsx(Text, {
                                    text: props.caption,
                                    color: "white",
                                    textAlign: "center",
                                    weight: "semibold"
                                }) : props.caption
                            })
                        }) : null
                    ]
                }) : null,
                useBuiltInFullscreenPlayer ? /*#__PURE__*/ _jsx(MediaPlayer, {
                    initialPositionMillis: props.initialPositionMillis,
                    uri: props.uri,
                    ref: player,
                    allowMini: false,
                    autoPlay: false,
                    hideControls: true,
                    onFullscreenUpdate: function(param) {
                        var fullscreenUpdate = param.fullscreenUpdate;
                        if (fullscreenUpdate === VideoFullscreenUpdate.PLAYER_DID_DISMISS) {
                            if (player.current) {
                                void player.current.setIsPlayingAsync(false);
                            }
                        } else if (fullscreenUpdate === VideoFullscreenUpdate.PLAYER_DID_PRESENT) {
                            if (player.current) {
                                void player.current.setIsPlayingAsync(true);
                            }
                        }
                    },
                    onEnd: function() {
                        if (player.current) {
                            player.current.setPositionAsync(0);
                            void player.current.dismissFullscreenPlayer();
                        }
                    }
                }) : null,
                /*#__PURE__*/ _jsx(View, {
                    row: true,
                    style: useBuiltInFullscreenPlayer ? StyleSheet.absoluteFillObject : null,
                    children: /*#__PURE__*/ _jsx(View, {
                        style: {
                            aspectRatio: (_props_previewAspectRatio = props.previewAspectRatio) !== null && _props_previewAspectRatio !== void 0 ? _props_previewAspectRatio : 16 / 9,
                            width: '100%',
                            flexGrow: 1
                        },
                        children: /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: '100%',
                                height: '100%',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            children: [
                                ((_props_posterSource = props.posterSource) !== null && _props_posterSource !== void 0 ? _props_posterSource : previewUri) ? /*#__PURE__*/ _jsx(Image, {
                                    resizeMethod: "resize",
                                    source: (_props_posterSource1 = props.posterSource) !== null && _props_posterSource1 !== void 0 ? _props_posterSource1 : {
                                        uri: previewUri
                                    },
                                    style: [
                                        StyleSheet.absoluteFillObject,
                                        {
                                            height: '100%',
                                            width: '100%',
                                            borderRadius: props.borderRadius
                                        }
                                    ]
                                }) : isAudioURI(props.uri) ? /*#__PURE__*/ _jsx(View, {
                                    pointerEvents: "none",
                                    style: [
                                        StyleSheet.absoluteFillObject,
                                        {
                                            zIndex: 1,
                                            top: 0,
                                            bottom: 0,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            paddingTop: 10,
                                            paddingLeft: 20
                                        }
                                    ],
                                    row: true,
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        name: "audio",
                                        size: 80,
                                        color: "rgba(0,0,0,0.1)"
                                    })
                                }) : /*#__PURE__*/ _jsx(View, {
                                    style: [
                                        StyleSheet.absoluteFillObject,
                                        {
                                            zIndex: 1,
                                            top: 0,
                                            bottom: 0,
                                            alignItems: 'center',
                                            alignSelf: 'center',
                                            justifyContent: 'center'
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(ActivityIndicator, {
                                        size: "small"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 75,
                                        height: 75,
                                        backgroundColor: 'rgba(255,255,255,0.8)',
                                        borderRadius: 75 / 2
                                    },
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        color: theme.color.primary100,
                                        name: "play",
                                        size: 40
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
});
